import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import LoadingOverlay from '../../components/loading/loading';
import authService from '../../services/authService';

const SignUpPage = () => {
    const push = useNavigate();
    const [loading, setLoading] = useState(false);

    const [value, setValue] = useState({
        firstName: "",
        lastName: "",
        username: "",
        contact_number: "",
        invitationCode: "",
        password: "",
        confirmPassword: "",
    });

    const changeHandler = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        validator.showMessages();
    };
    
    const blurHandler = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value.trim() });
        validator.showMessages();
    };    

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setLoading(true);
            setValue({
                firstName: "",
                lastName: "",
                username: "",
                contact_number: "",
                invitationCode: "",
                password: "",
                confirmPassword: "",
            });
            validator.hideMessages();
            const { firstName, lastName, username, contact_number, password, invitationCode } = value;
            try {
                const userData = { firstName, lastName, username, contact_number, password, invitationCode };
                const result = await authService.users(userData, "register");
                if (result && !result.success) {
                    toast.error(result.message + ' ' + result.displayMessage);
                    return;
                }
                toast.success(result.message + ' ' + result.displayMessage);
                push('/login');
            } catch (error) {
                toast.error('An error occurred during signup.');
            } finally {
                setLoading(false);
            }
        } else {
            validator.showMessages();
            toast.error('Empty field is not allowed!');
        }
    };

    return (
        <Grid className="loginWrapper">
            {loading && <LoadingOverlay />}
            <Grid className="loginForm">
                <h2>Signup</h2>
                <p>Signup your account</p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="John"
                                value={value.firstName}
                                variant="outlined"
                                name="firstName"
                                label="First Name"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                            {validator.message('First Name', value.firstName, 'required|alpha')}
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Doe"
                                value={value.lastName}
                                variant="outlined"
                                name="lastName"
                                label="Last Name"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                            {validator.message('Last Name', value.lastName, 'required|alpha')}
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="johndoe"
                                value={value.username}
                                variant="outlined"
                                name="username"
                                label="Username"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                            {validator.message('Username', value.username, 'required')}
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="+123456789"
                                value={value.contact_number}
                                variant="outlined"
                                name="contact_number"
                                label="Contact Number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                            {validator.message('contact_number', value.contact_number, 'required')}
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="********"
                                value={value.password}
                                variant="outlined"
                                name="password"
                                type="text"
                                label="Password"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                            {validator.message('password', value.password, 'required')}
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="********"
                                value={value.confirmPassword}
                                variant="outlined"
                                name="confirmPassword"
                                type="text"
                                label="Confirm Password"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                            {validator.message('Confirm Password', value.confirmPassword, `in:${value.password}`)}
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="ABC123"
                                value={value.invitationCode}
                                variant="outlined"
                                name="invitationCode"
                                label="Invitation Code"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={blurHandler}
                                onChange={changeHandler}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtn cBtnLarge cBtnTheme" type="submit">Sign Up</Button>
                            </Grid>
                            <p className="noteHelp">Already have an account? <Link to="/login">Return to Sign In</Link></p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default SignUpPage;
